<template>
  <div class="app-box">
  	<div class="app-box-ewm">
  		<div class="app-box-ewm-item">
  			<div class="app-box-ewm-item-img">
  				<canvas v-if="androidUrl" ref="androidCanvas"></canvas>
  				<div v-else class="app-box-ewm-item-empty">
  					<span>{{$t('all.weixiazai')}}</span>
  				</div>
  			</div>
			<div class="app-box-ewm-item-des">{{$t('all.anzhuoxiazai')}}</div>
			<div class="app-box-ewm-item-div">
				<img src="../../assets/image/anzhuo.png" alt="" />
				<div class="app-box-ewm-item-div-content">
					<span class="app-box-ewm-item-div-content-span">GET IN ON</span>
					<span class="app-box-ewm-item-div-content-span1">{{$t('all.anzhuoxiazai')}}</span>
				</div>
			</div>
  		</div>
		<div class="app-box-ewm-item">
			<div class="app-box-ewm-item-img">
				<canvas v-if="iosUrl" ref="iosCanvas"></canvas>
				<div v-else class="app-box-ewm-item-empty">
					<span>{{$t('all.weixiazai')}}</span>
				</div>
			</div>
			<div class="app-box-ewm-item-des">{{$t('all.pingguoxiazai')}}</div>
			<div class="app-box-ewm-item-div">
				<img src="../../assets/image/pingguo.png" alt="" />
				<div class="app-box-ewm-item-div-content">
					<span class="app-box-ewm-item-div-content-span">Download on the</span>
					<span class="app-box-ewm-item-div-content-span1">{{$t('all.pingguoxiazai')}}</span>
				</div>
			</div>
		</div>
  	</div>
  </div>
</template>

<script>
import { getAppDownloadConfig } from "@/api/user";
import QRCode from 'qrcode';
export default {
  data() {
    return {
	  data: '',
	  androidUrl: '',
	  iosUrl: ''
    };
  },
  mounted() {
	this.getAppDownloadConfig()
  },
  watch: {
	androidUrl(val) {
		if (val) {
			this.$nextTick(() => {
				setTimeout(() => {
					this.generateAndroidQRCode()
				}, 100)
			})
		}
	},
	iosUrl(val) {
		if (val) {
			this.$nextTick(() => {
				setTimeout(() => {
					this.generateIosQRCode()
				}, 100)
			})
		}
	}
  },
  methods: {
	async getAppDownloadConfig(){
		try {
			const res = await getAppDownloadConfig()
			this.data = res.data
			console.log('APP下载配置:', this.data)
			this.resolveDownloadUrl()
			console.log('解析后的下载地址 - Android:', this.androidUrl, 'iOS:', this.iosUrl)
			this.$nextTick(() => {
				this.generateQRCodes()
			})
		} catch (error) {
			console.error('获取下载配置失败:', error)
		}
	},
	resolveDownloadUrl() {
		if (!this.data) return
		const isInternational = this.isInternationalVersion()
		if (isInternational) {
			this.androidUrl = this.data.androidDownloadUrl || ''
			this.iosUrl = this.data.iosDownloadUrl || ''
		} else {
			this.androidUrl = this.data.androidUrl || ''
			this.iosUrl = this.data.iosUrl || ''
		}
	},
	isInternationalVersion() {
		const lang = localStorage.getItem('language') || 'tw'
		const internationalLangs = ['en', 'ja', 'ko']
		return internationalLangs.includes(lang)
	},
	async generateQRCodes() {
		if (this.androidUrl) {
			await this.generateAndroidQRCode()
		}
		if (this.iosUrl) {
			await this.generateIosQRCode()
		}
	},
	async generateAndroidQRCode() {
		if (!this.$refs.androidCanvas) {
			console.error('安卓Canvas不存在')
			return
		}
		try {
			await QRCode.toCanvas(this.$refs.androidCanvas, this.androidUrl, {
				width: 220,
				margin: 2,
				color: {
					dark: '#000000',
					light: '#ffffff'
				}
			})
			console.log('安卓二维码生成成功')
		} catch (error) {
			console.error('生成安卓二维码失败:', error)
		}
	},
	async generateIosQRCode() {
		if (!this.$refs.iosCanvas) {
			console.error('iOS Canvas不存在')
			return
		}
		try {
			await QRCode.toCanvas(this.$refs.iosCanvas, this.iosUrl, {
				width: 220,
				margin: 2,
				color: {
					dark: '#000000',
					light: '#ffffff'
				}
			})
			console.log('iOS二维码生成成功')
		} catch (error) {
			console.error('生成iOS二维码失败:', error)
		}
	}
  }
};
</script>
<style scoped lang="scss">
	@import "./appxiazai.css";
</style>



// WEBPACK FOOTER //
// appxiazai.vue?8531cac8